module.exports = __webpack_public_path__ + "img/Ella.c1732cf2.jpg";